import { createSlice } from "@reduxjs/toolkit";
import { rolesApiSlice } from "./rolesApiSlice";

export const initialState = {
  all: {
    data: [],
    page: 1,
    size: 0,
    totalData: 0,
  },
  one: {
    role_title: "",
    description: "",
    role_type: "",
    is_active: false,
    is_seller: false,
  },
  query: {},
  chosen_roles: [],
};

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      state.query[action.payload.key] = action.payload.value;
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
    clearChosenRole: (state, action) => {
      state.chosen_roles = initialState.chosen_roles;
    },
    addChosenRole: (state, action) => {
      const roleIndex = state.chosen_roles.indexOf(action.payload);

      if (roleIndex >= 0) {
        const updatedChosenRoles = [...state.chosen_roles];
        updatedChosenRoles.splice(roleIndex, 1);
        state.chosen_roles = updatedChosenRoles;
      } else {
        state.chosen_roles = [...state.chosen_roles, action.payload];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        rolesApiSlice.endpoints.loadAllRoles.matchFulfilled,
        (state, { payload }) => {
          state.all = payload;
        }
      )
      .addMatcher(
        rolesApiSlice.endpoints.loadOneRoleDetails.matchFulfilled,
        (state, action) => {
          state.one = action.payload.data;
        }
      );
  },
});

export const {
  setQueryValue,
  addChosenRole,
  clearChosenRole,
  setOneValue,
  clearOne,
} = rolesSlice.actions;

export default rolesSlice.reducer;
